import React, { useEffect, useRef, useState } from "react";
import { connect, useSelector } from "react-redux";
import { Card, IconButton } from "@mui/material";
import { Clear as ClearIcon, PieChart as PieChartIcon, SsidChart, TableChart } from "@mui/icons-material";
import { t } from "i18next";
import { setTokenTimer } from "../../redux/actions";
import AppConfig from "../../helpers/constants/AppConfig";
import MDBox from "../MDs/MDBox";
import MDTypography from "../MDs/MDTypography";
import "./graphCard.css";

function GraphCard({ children, graphData, getChart, title, handleGraphClear, clearable, noRefresh, isPng, setTokenTimer }) {
  const refreshRate = useSelector(state => state.refresh_rate);
  const [timeUpdated, setTimeUpdated] = useState(new Date());
  const timeoutRef = useRef();

  useEffect(() => {
    return () => window.clearTimeout(timeoutRef.current);
  }, []);

  useEffect(() => {
    if (!noRefresh) {
      let rt = refreshRate * 1000;
      window.clearTimeout(timeoutRef.current);
      timeoutRef.current = window.setTimeout(
         () => {
           timeoutRef.current = null;
           setTimeUpdated(new Date());
           setTokenTimer();
           if (graphData.type === "chart" || graphData.type === "statistic") {
             getChart();
           }
         }, rt
      );
    }
  }, [timeUpdated]);

  const handleClear = () => {
    handleGraphClear();
    window.clearTimeout(timeoutRef.current);
  };

  return (
     <Card>
       <MDBox padding="0.5rem">
         <MDBox py={0.5} px={0.5} sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
           <MDBox display="flex" px={1} pt={1}>
             <MDBox
                width="4rem"
                height="4rem"
                bgColor={AppConfig.color}
                variant="gradient"
                coloredShadow={AppConfig.color}
                borderRadius="xl"
                display="flex"
                justifyContent="center"
                alignItems="center"
                color="white"
                mr={2}
             >
               {graphData.type === "chart" && <PieChartIcon style={{ fontSize: '33px' }} />}
               {graphData.type === "img" && <SsidChart style={{ fontSize: '33px' }} />}
               {graphData.type === "statistic" && <TableChart style={{ fontSize: '33px' }} />}
             </MDBox>
             <MDBox mt={1}>
               <MDTypography variant="h6">{title}</MDTypography>
               {!noRefresh && (
                  <MDTypography component="div" variant="button" color="text" fontWeight="light" sx={{ fontSize: '12px', fontStyle: 'italic' }}>
                    {t("dashboard.last_updated")}:
                    {" "}
                    <span style={{ fontSize: 'smaller' }}>
                        { timeUpdated.getHours()<= 9 ? '0'+timeUpdated.getHours() : timeUpdated.getHours() }
                        {":"}
                        { timeUpdated.getMinutes() <= 9 ? "0" + timeUpdated.getMinutes() : timeUpdated.getMinutes() }
                        {":"}
                        { timeUpdated.getSeconds() <= 9 ? "0" + timeUpdated.getSeconds() : timeUpdated.getSeconds() }
                    </span>
                  </MDTypography>
               )}
             </MDBox>
           </MDBox>

           {clearable &&
              <IconButton color="error" onClick={handleClear}>
                <ClearIcon sx={{ fontSize: '25px' }} />
              </IconButton>
           }
         </MDBox>

         {/* img or chart */}
         {React.cloneElement(
            children, {
              timeUpdated,
              graphData,
              noRefresh,
              isPng
            }
         )}
       </MDBox>
     </Card>
  );
}

const mapDispatchToProps = dispatch => {
  return {
    setTokenTimer: () => dispatch(setTokenTimer())
  }
}

export default connect(null, mapDispatchToProps)(GraphCard);
